module.exports = __webpack_public_path__ + "static/OP1-31bec0733547959e1439d6a19407bbed.jpg";